//
// Job Carousel Functions
//
import { Carousel } from "@fancyapps/ui";

export default class JobCarousel {
  constructor() {

    this.jobCarousels = document.querySelectorAll('.js-image-carousel');

    const options = {
      transition: "fade",
      infinite: true,
      Navigation: {
        nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 54" fill="none"><path d="M13.7408 37.4002C9.42408 40.4962 0.869439 45.0744 0.0928041 50.0948C-1.1349 58.0297 10.1794 51.655 12.6891 50.2072C19.1602 46.4743 25.4637 42.4719 31.9295 38.7208C36.6487 35.9832 44.0475 32.68 42.8761 25.4758C41.8104 18.9215 32.63 14.7083 28.0191 11.4748C22.3485 7.49807 15.5747 2.83544 9.06415 0.632221C1.60597 -1.89186 0.0928055 3.58605 3.81809 9.20807C12.6891 16.1895 26.4338 20.7881 26.4338 25.9006C26.4338 30.1182 25.7419 28.793 13.7408 37.4002Z" fill="currentColor"/></svg>',
        prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 54" fill="none"><path d="M29.2592 16.5998C33.5759 13.5038 42.1306 8.9256 42.9072 3.9052C44.1349 -4.02966 32.8206 2.34501 30.3109 3.79283C23.8398 7.52566 17.5363 11.5281 11.0705 15.2792C6.35128 18.0168 -1.04747 21.32 0.123943 28.5242C1.18964 35.0785 10.37 39.2917 14.9809 42.5252C20.6515 46.5019 27.4253 51.1646 33.9359 53.3678C41.394 55.8919 42.9072 50.414 39.1819 44.7919C30.3109 37.8105 16.5662 33.2119 16.5662 28.0994C16.5662 23.8818 17.2581 25.207 29.2592 16.5998Z" fill="currentColor"/></svg>'
      },
      breakpoints: {
        "(max-width: 1200px)": {
          Navigation: false,
        },
      },
    };

    this.jobCarousels.forEach(jobCarousel => {
      new Carousel(jobCarousel, options);
    });

  }
}